<template>
  <app-modal v-model="isDialogOpened"
             hide-header
             size="lg"
             @cancel="closeDialog"
  >
    <template #body>
      <ProjectTypeFeatureHeader :shadow-color="PROJECT_TYPE_COLORS.PROJECT"
                                :illustration="discoverProjectIllustration"
                                @close="closeDialog"
      >
        <template #title>
          <h3 class="text-light-blue">{{ $t('common.discover') }}</h3>
          <h1>{{ $t('projects.dialogs.DiscoverProjectDialog.moduleTitle') }}</h1>
        </template>
      </ProjectTypeFeatureHeader>

      <div class="copyright">
        <CopyrightLink author="fullvector"
                       link="https://fr.freepik.com/vecteurs-libre/achat-paiement-ligne-boutique-ligne-isometrique-reception-du-paiement-notification-achat_4102305.htm"
        />
      </div>
      <div class="features-list">
        <ProjectTypeFeaturesList :features="features" icon-class="text-light-blue" />
      </div>
    </template>

    <template #footer>
      <v-spacer />
      <AppButton color="white"
                 @click="closeDialog"
      >
        {{$t('common.cancel')}}
      </AppButton>

      <AppButton v-if="canCurrentUserCreateProject"
                 color="primary"
                 @click="createProject"
      >
        {{ $t("projects.dialogs.DiscoverProjectDialog.createProject") }}
      </AppButton>
      <AppButton v-else
                 color="primary"
                 @click="requestActivation"
      >
        {{ $t("projects.dialogs.DiscoverProjectDialog.activate") }}
      </AppButton>
    </template>
  </app-modal>
</template>

<script>
import { mapGetters } from 'vuex'

import discoverProjectIllustration from '@/assets/img/discover_project.svg'
import AppButton from '@/common/buttons/AppButton.vue'
import CopyrightLink from '@/common/CopyrightLink.vue'
import { dialogMixin } from '@/mixins/dialogMixin'
import { PROJECT_TYPE_COLORS } from '@/projects/dialogs/projectTypeColors'

import ProjectTypeFeatureHeader from '../project-types/ProjectTypeFeatureHeader.vue'
import ProjectTypeFeaturesList from '../project-types/ProjectTypeFeaturesList.vue'

const FEATURES_ICONS = {
  1: 'signature',
  2: 'schedule',
  3: 'lock',
}

export default {
  name: 'DiscoverProjectDialog',
  components: { AppButton, CopyrightLink, ProjectTypeFeatureHeader, ProjectTypeFeaturesList },
  mixins: [dialogMixin],
  data () {
    return {
      PROJECT_TYPE_COLORS,
      discoverProjectIllustration,
      features: Object.keys(FEATURES_ICONS).map(key => ({
        icon: FEATURES_ICONS[key],
        title: this.$t(`projects.dialogs.DiscoverProjectDialog.features.${key}.title`),
        description: this.$t(`projects.dialogs.DiscoverProjectDialog.features.${key}.description`),
      })),
    }
  },
  computed: {
    ...mapGetters('user', ['canCurrentUserCreateProject']),
  },
  methods: {
    createProject () {
      this.$emit('createProject')
    },
    requestActivation () {
      this.closeDialog()
      this.$emit('requestActivation')
    },
  },
}
</script>

<style scoped lang="scss">
.features-list {
  margin: 0 45px;
  max-width: 600px;
}

@media (max-width: 768px) {
  .features-list {
    margin: 0 20px;
  }
}

.copyright {
  position: absolute;
  right: -20px;
  transform: rotate(-90deg);
}
</style>
